/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  today: '××××',
  now: '×¢××©××',
  backToToday: '××××¨ ×××××',
  ok: '×××©××¨',
  clear: '×××¤××¡',
  month: '××××©',
  year: '×©× ×',
  timeSelect: '×××¨ ×©×¢×',
  dateSelect: '×××¨ ×ª××¨××',
  weekSelect: '×××¨ ×©×××¢',
  monthSelect: '×××¨ ××××©',
  yearSelect: '×××¨ ×©× ×',
  decadeSelect: '×××¨ ×¢×©××¨',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: '××××© ×§××× (PageUp)',
  nextMonth: '××××© ××× (PageDown)',
  previousYear: '×©× × ×©×¢××¨× (Control + left)',
  nextYear: '×©× × ×××× (Control + right)',
  previousDecade: '××¢×©××¨ ××§×××',
  nextDecade: '××¢×©××¨ ×××',
  previousCentury: '×××× ××§××××ª',
  nextCentury: '×××× ××××'
};
